import PatientDetails from './PatientDetailsSummary';
export default PatientDetails;
